/*  /frontend/src/index.js
    Greatly Social – root entry
    FULL FILE — NOTHING OMITTED
    -------------------------------------------------------------- */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from '@dr.pogodin/react-helmet';

import App from './App';
import { UserProvider } from './context/UserContext';
import { LoadingProvider } from './context/LoadingContext';
import { AccountsProvider } from './context/AccountsContext';

/* ─── third-party styles ─── */
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';

/* expose React for devtools / legacy scripts */
window.React = React;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  /*  Wrap the entire app exactly once  */
  <HelmetProvider>
    <LoadingProvider>
      <UserProvider>
        <AccountsProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AccountsProvider>
      </UserProvider>
    </LoadingProvider>
  </HelmetProvider>
);
